export function formatGrade (grade) {
  const num = parseInt(grade, 10);

  if (grade === '0' || num === 0) return 'K';
  if (num === 1) return '1st';
  if (num === 2) return '2nd';
  if (num === 3) return '3rd';
  if (!isNaN(num)) return num + 'th';

  return grade;
}
